<nz-icon *ngIf="!valid" [nzType]="'warning'" nzTheme="twotone" nzTwotoneColor="#eb2f96" (click)="openDrawer()"/>

<!--
<nz-icon *ngIf="!form.valid" [nzType]="'warning'" nzTheme="twotone" nzTwotoneColor="#eb2f96" nz-tooltip [nzTooltipTitle]="titleTemplate"/>
<ng-template #titleTemplate let-thing>
	<ul>
		<li *ngFor="let item of getInvalidControlsList()">
			<b>{{item.field}}: </b>
			{{item. errors}}
		</li>
	</ul>
</ng-template>
-->
